import * as Sentry from '@sentry/react';
import type { Metric } from 'web-vitals';

const isDev =
  typeof process !== 'undefined' &&
  (process.env?.NX_ENV === 'development' || process.env?.NODE_ENV === 'development');

function sanitizeForLog(s: string): string {
  return String(s).replace(/[\r\n]+/g, ' ').trim();
}

function reportToConsole(metric: Metric): void {
  if (isDev && typeof console?.log === 'function') {
    const name = sanitizeForLog(metric.name);
    const id = metric.id != null ? sanitizeForLog(String(metric.id)) : metric.id;
    console.log(`[Web Vitals] ${name}:`, metric.value, { ...metric, name, id });
  }
}

function reportToSentry(metric: Metric): void {
  try {
    const name = sanitizeForLog(metric.name);
    const id = metric.id != null ? sanitizeForLog(String(metric.id)) : metric.id;
    Sentry.addBreadcrumb({
      category: 'web-vitals',
      message: `${name}: ${metric.value}`,
      data: { value: metric.value, delta: metric.delta, id },
      level: 'info',
    });
  } catch {
    // ignore if Sentry not ready
  }
}

export function initWebVitals(): void {
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    const report = (metric: Metric) => {
      reportToConsole(metric);
      reportToSentry(metric);
    };
    getCLS(report);
    getFID(report);
    getFCP(report);
    getLCP(report);
    getTTFB(report);
  });
}

